import ApiService from '../../../../../services/ApiService'
import GeneralService from '../../../../../services/GeneralService'
import Utils from '../../../../../Utils/FormatDate'

export default {
  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id

    if (this.institution.userType > 1) {
      await this.getUserUnidades()
    } else {
      await this.getUnidades()
    }

    await Promise.all([
      this.getInstitutions(),
      this.getDepartments(),
      this.getStandardEquipment(),
      this.getManufacturers(),
    ])

    if (this.unidades.length == 1) {
      this.unidadeId = this.unidades[0].id
    }

    await this.updateTable()
  },

  data: () => ({
    institution: {},
    departmentSearch: '',
    selected: [],
    loading: false,
    institutionLoading: false,
    unidadeLoading: false,
    departmentLoading: false,
    deleteLoading: false,
    deleteDialog: false,
    menuStartDate: false,
    menuEndDate: false,
    visible: false,
    startDate: null,
    endDate: null,
    minDate: null,
    expanded: [],
    currentCalibration: {},
    calibrations: [],
    institutionId: null,
    institutions: [],
    unidadeId: null,
    unidades: [],
    departmentId: null,
    departments: [],
    userLogged: {},
    page: 1,
    totalPages: 1,
    pageSize: 10,
    sizes: [10, 25, 50, 100],
    totalItems: 0,
    totalItensOnPage: 0,
    filter: {
      validated: null,
      page: 1,
      pageSize: 10,
      institutionId: null,
      unidadeId: null,
      departmentId: null,
      standardEquipments: null,
      equipment: null,
      model: null,
      manufacturer: null,
      serialNumber: null,
      identification: null,
      propertyCode: null,
      serviceOrderNumber: null,
      certifiedNumber: null,
      calibrationStartDate: null,
      calibrationEndDate: null,
      result: null,
    },
    standardEquipment: null,
    standardEquipments: [],
    equipment: null,
    model: null,
    manufacturer: null,
    serialNumber: null,
    identification: null,
    propertyCode: null,
    serviceOrderNumber: null,
    certifiedNumber: null,
    calibrationStartDate: null,
    calibrationEndDate: null,
    result: null,
    calibrationResults: ['Aprovado', 'Reprovado'],
    headers: [
      {
        text: '',
        align: 'center',
        value: '',
        sortable: false,
      },
      {
        text: 'Identificação',
        align: 'center',
        value: 'equipment.identification',
      },
      {
        text: 'Equipamento',
        align: 'center',
        value: 'equipment.name',
      },
      {
        text: 'Nº OS',
        align: 'center',
        value: 'serviceOrder.number',
      },
      {
        text: 'Data Calibração/Certificado',
        align: 'center',
        value: 'calibrationDate',
      },
      {
        text: 'Ações',
        align: 'center',
        value: 'actions',
        sortable: false,
        width: 400,
      },
    ],
    headersMobile: [
      {
        text: 'Identificação',
        align: 'center',

        value: 'identification',
        sortable: false,
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    apiService: new ApiService(),
    generalService: new GeneralService(),
    standardEquipmentLoading: false,
    manufacturers: [],
  }),

  computed: {},

  methods: {
    removeStandardEquipment(item) {
      this.filter.standardEquipments.splice(item, 1)
      this.filter.standardEquipments = [...this.filter.standardEquipments]
    },
    removeDepartment(item) {
      this.filter.departmentIds.splice(item, 1)
      this.filter.departmentIds = [...this.filter.departmentIds]
    },
    getManufacturers() {
      this.manufacturerLoading = true
      this.apiService
        .get(`manufacturer/list/${this.institutionId}`)
        .then((response) => {
          this.manufacturers = response.content
          this.manufacturerLoading = false
        })
        .catch(() => {
          this.manufacturerLoading = false
        })
    },

    async getZip() {
      this.$toast(
        `${this.$t('Imprimindo registros')}: ${this.selected.length} ${this.$t(
          'selecionados'
        )}`
      )
      const ids = this.selected.map((x) => x.id)
      await this.apiService
        .post(`calibration/getZipCalibrations`, { ids })
        .then((response) => {
          var pedfResult = 'data:application/zip;base64,' + response.content
          const link = document.createElement('a')
          link.href = pedfResult
          link.setAttribute('download', `Calibrações`)
          document.body.appendChild(link)
          link.click()
          this.selected = []
        })
    },

    async getUserUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/listByUserAndInstitution/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getStandardEquipment() {
      this.standardEquipmentLoading = true

      this.standardEquipments =
        await this.generalService.getStandardEquipmentsByInstitution(
          this.institutionId
        )

      this.standardEquipmentLoading = false
    },

    filterTable() {
      this.page = 1
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.filter.unidadeId = this.unidadeId
      this.filter.equipment = this.equipment
      this.filter.model = this.model
      this.filter.manufacturer = this.manufacturer
      this.filter.serialNumber = this.serialNumber
      this.filter.identification = this.identification
      this.filter.propertyCode = this.propertyCode
      this.filter.serviceOrderNumber = this.serviceOrderNumber
      this.filter.certifiedNumber = this.certifiedNumber
      this.filter.calibrationStartDate = this.calibrationStartDate
      this.filter.calibrationEndDate = this.calibrationEndDate
      this.filter.result =
        this.result != null
          ? this.calibrationResults.indexOf(this.result)
          : this.result
      this.updateTable()
    },

    isInactive(value) {
      return value.equipment && value.equipment.department.status == 1
        ? 'departmentInactive'
        : ''
    },

    editCalibrationData(value) {
      if (this.institution.userType == 4 || this.institution.userType == 5)
        return

      let routeData = this.$router.resolve(
        `/calibrationCertified/${value.serviceOrder.id}`
      )
      window.open(routeData.href, '_blank')
    },

    openServiceOrder(value) {
      const route = this.$router.resolve({
        path: `/editServiceOrder/${value.serviceOrderId}`,
      })
      window.open(route.href, '_blank')
    },

    openCalibration(value) {
      sessionStorage.setItem('serviceOrder', JSON.stringify(value.serviceOrder))
      this.$router.push('/formCalibration')
    },

    deleteCalibration(value) {
      this.currentCalibration = value
      this.deleteDialog = true
    },

    async openCertified(calibration) {
      const route = this.$router.resolve({
        path: `/printCalibrationCertified/${this.institutionId}/${calibration.id}`,
      })
      window.open(route.href, '_blank')
    },

    async printCalibration(calibration) {
      await this.apiService
        .post('calibration/printCalibration', calibration)
        .then((response) => {
          var w = window.open('')
          w.document.write(response.content.html)

          var pedfResult = 'data:application/pdf;base64,' + response.content.pdf
          const link = document.createElement('a')
          link.href = pedfResult
          link.setAttribute('download', `Calibração Nº ${calibration.number}`)
          document.body.appendChild(link)
          link.click()
        })
    },

    async updateTable() {
      this.loading = true
      this.filter.institutionId = this.institutionId

      await this.apiService
        .post('calibration/list', this.filter)
        .then((response) => {
          this.totalPages = response.content.pager.totalPages
          this.calibrations = response.content.calibrations
          this.totalItems = response.content.pager.totalItems
          this.totalItensOnPage = response.content.calibrations.length
          this.loading = false
        })
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService.get('institution/list').then((response) => {
        this.institutions = response.content
        this.institutionLoading = false
      })
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getDepartments() {
      this.departmentLoading = true

      await this.apiService
        .get(`department/listActive/${this.institutionId}`)
        .then((response) => {
          this.departments = response.content
          this.departmentLoading = false
        })
    },

    async removeCalibration() {
      this.deleteLoading = true

      await this.apiService
        .delete('calibration/delete', this.currentCalibration)
        .then((response) => {
          this.deleteLoading = false
          this.deleteDialog = false
          this.updateTable()
        })
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    save(date) {
      this.startDate = this.formatInputDate(this.calibrationStartDate)
      this.$refs.menuStartDate.save(date)
      this.minDate = new Date(this.calibrationStartDate)
        .toISOString()
        .substr(0, 10)
      this.endDate = this.formatInputDate(this.calibrationEndDate)
      this.$refs.menuEndDate.save(date)
    },

    reset() {
      this.filter = {
        validated: null,
        page: 1,
        pageSize: this.pageSize,
        institutionId: null,
        unidadeId: null,
        departmentIds: null,
        standardEquipments: null,
        equipment: null,
        model: null,
        manufacturer: null,
        serialNumber: null,
        identification: null,
        propertyCode: null,
        serviceOrderNumber: null,
        certifiedNumber: null,
        calibrationStartDate: null,
        calibrationEndDate: null,
        result: null,
      }

      this.standardEquipment = null
      this.equipment = null
      this.model = null
      this.manufacturer = null
      this.serialNumber = null
      this.identification = null
      this.propertyCode = null
      this.serviceOrderNumber = null
      this.certifiedNumber = null
      this.calibrationStartDate = null
      this.calibrationEndDate = null
      this.unidadeId = this.institution.userType > 1 ? this.unidadeId : null
      this.departmentId = null
      this.startDate = null
      this.endDate = null
      this.result = null

      this.updateTable()
    },

    selectItems() {
      this.$nextTick(() => {
        if (this.selected.length < 25) {
          this.selected = this.calibrations.slice(0, 25)
        } else if (this.selected.length == 25) {
          this.selected = []
        }
      })
    },
  },

  watch: {
    pageSize() {
      this.filter.pageSize = this.pageSize
      this.filter.page = 1
      this.updateTable()
    },

    page() {
      this.filter.page = this.page
      this.updateTable()
    },
  },
}
